module.exports = __webpack_public_path__ + "img/Indonesia-5.1553013a.jpg";